import styled from '@emotion/styled';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { withConfig } from 'src/withConfig';
interface FormStyledPropsType {
    isMessage: boolean;
}
export const AccountReviewFormWrapper = styled('div', { label: 'AccountReviewFormWrapper' })<FormStyledPropsType>`
    margin-bottom: ${(props): string => props.isMessage ? '60px' : '50px'};
`;

export const AccountReviewStatusContainer = styled('div', { label: 'AccountReviewStatusContainer' })`
    margin: 0 0 16px;
`;

export const AccountReviewNextDate = styled('strong', { label: 'AccountReviewNextDate' })`
    float: right;
`;

export const AccountReviewParagraph = withConfig(theme => styled('p', { label: 'AccountReviewParagraph' })`
    line-height: 1.4285;
    margin: 0 0 16px;
    font-size: ${theme.star.fontSize.xRegular};
`);

export const SectionHeader = withConfig(theme => styled('h4', { label: 'SectionHeader' })`
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    margin: 0 0 4px;
`);

export const AccountReviewButton = styled(Button, { label: 'AccountReviewButton' })`
    width: 100%;
`;
